export enum BudgetViewMode {
  EXPENSE = 'expense',
  INCOME = 'income',
  SAVING = 'saving',
  RECONCILIATION = 'reconciliation'
}
